import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import * as Icons from "lucide-react";
import { getUserFromToken } from "../../../Utils/TokenVerify";
import { LogoutUser } from "../../../Services/Admin/Addmin";
import Swal from "sweetalert2";

const Profile = () => {
  const navigate = useNavigate();
  const TokenData = getUserFromToken();
  const user_id = TokenData?.user_id;
  const username = TokenData?.UserName || "User";
  const email = TokenData?.Email || "";

  const logoutuser = async () => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to logout?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, logout",
        cancelButtonText: "No, stay",
      });

      if (result.isConfirmed) {
        const response = await LogoutUser({ userid: user_id });
        if (response.status) {
          localStorage.clear();
          Swal.fire({
            icon: "success",
            title: "Logged out!",
            text: "You have been logged out successfully.",
            timer: 1500,
            showConfirmButton: false,
          });
          navigate("/login");
        }
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while logging out.",
      });
    }
  };

  const menuItems = [
    { name: "Trade Statement", icon: Icons.FileText, route: "/user/trade-statement" },
    { name: "Ledger Report", icon: Icons.Book, route: "/user/ledger-report" },
    { name: "Balance Statement", icon: Icons.Wallet, route: "/user/balance-statement" },
    { name: "Registered Bank", icon: Icons.Building, route: "/user/bank-details" },
    { name: "Kyc Document", icon: Icons.Building, route: "/user/kyc" },
    { name: "Privacy Policy", icon: Icons.Shield, route: "/user/privacy-policy" },
    { name: "Terms & Conditions", icon: Icons.Scale, route: "/user/terms" },
    { name: "Refer & Earn", icon: Icons.Share2, route: "/user/refer" },
  ];

  return (
    <div className="mobile-profile-container pb-5 mb-5 container-fluid bg-body text-body">
      <style>
        {`
          .mobile-profile-container {
            min-height: 100vh;
            font-family: 'Inter', sans-serif;
            padding: 20px 15px;
            margin-top: -100px;
            position: relative;
            z-index: 10;
          }
          @media (min-width: 769px) {
             .mobile-profile-container {
                 display: none;
             }
          }
          .profile-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 25px;
            padding-top: 20px;
          }
          .profile-title {
            font-size: 1.25rem;
            font-weight: 600;
          }
          .user-card {
            border-radius: 20px;
            padding: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 25px;
          }
          .user-info {
            display: flex;
            align-items: center;
            gap: 15px;
          }
          .user-avatar {
            width: 60px;
            height: 60px;
            background-color: var(--bs-secondary-bg, #e9ecef);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 2px solid var(--bs-success, #28a745);
          }
          .user-avatar img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
          .user-details h3 {
            margin: 0;
            font-size: 1.1rem;
            display: flex;
            align-items: center;
            gap: 10px;
          }
          .badge-standard {
            background-color: var(--bs-primary, #007bff);
            color: white;
            font-size: 0.7rem;
            padding: 3px 8px;
            border-radius: 10px;
            font-weight: 500;
          }
          .user-details p {
            margin: 5px 0 0;
            font-size: 0.85rem;
          }
          .menu-list {
            display: flex;
            flex-direction: column;
            gap: 12px;
            margin-bottom: 30px;
          }
          .menu-item {
            border-radius: 12px;
            padding: 16px 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            text-decoration: none;
            transition: opacity 0.2s;
            border: 1px solid var(--bs-border-color, #dee2e6);
          }
          .menu-left {
            display: flex;
            align-items: center;
            gap: 15px;
          }
          .menu-icon {
            color: var(--bs-success, #20c997);
          }
          .menu-text {
            font-size: 0.95rem;
            font-weight: 500;
          }
          .logout-btn {
            background-color: rgba(255, 77, 77, 0.1);
            border-radius: 12px;
            padding: 16px 20px;
            display: flex;
            align-items: center;
            gap: 15px;
            color: #ff4d4d;
            border: 1px solid rgba(255, 77, 77, 0.2);
            width: 100%;
            cursor: pointer;
            margin-top: 30px;
            font-size: 0.95rem;
            font-weight: 500;
            transition: background-color 0.2s;
          }
        `}
      </style>

      {/* TOP SECTION: PROFILE INFO */}
      <div className="profile-header text-body">
        <Icons.ArrowLeft size={24} onClick={() => navigate(-1)} style={{ cursor: "pointer" }} />
        <span className="profile-title">Profile</span>
        <Icons.MoreVertical size={24} />
      </div>

      <div className="user-card card shadow-sm border-0 bg-body-tertiary mt-5" >
        <div className="user-info">
          <div className="user-avatar">
            <img src="/assets/images/avatar/1.png" alt="User Avatar" />
          </div>
          <div className="user-details">
            <h3>
              {username} <span className="badge-standard">Standard</span>
            </h3>
            <p className="text-muted">
              <Icons.User size={12} style={{ display: "inline", marginRight: "4px" }} />
              User: {email.split("@")[0] || username}
            </p>
          </div>
        </div>
        <Icons.ChevronDown size={24} className="text-muted" />
      </div>

      {/* MIDDLE SECTION: ALL TABS */}
      <div className="menu-list">
        {menuItems.map((item, index) => (
          <Link to={item.route} key={index} className="menu-item bg-body-tertiary text-body">
            <div className="menu-left">
              <item.icon size={20} className="menu-icon" />
              <span className="menu-text">{item.name}</span>
            </div>
            <Icons.ChevronRight size={20} className="text-muted" />
          </Link>
        ))}
      </div>

      <button className="logout-btn" onClick={logoutuser}>
        <Icons.LogOut size={20} />
        <span>Logout</span>
      </button>

    </div>
  );
};

export default Profile;
